import slugify from 'slugify'
import { trackCustomEvent } from './open-telemetry'

declare global {
  interface Window {
    dataLayer: unknown[]
  }
}

export const dispatchAnalytics = (params: any) => {
  const { event, ...attributes } = params

  const serializedAttributes = JSON.parse(JSON.stringify(attributes))

  if (!window.dataLayer) {
    console.error('dataLayer is not defined')
    return
  }

  window.dataLayer.push(params)
  trackCustomEvent(event, serializedAttributes)
}

export interface EventInterface {
  category: string
  action: string
  label: string
}

export const pushAnalytics = ({ category, action, label }: EventInterface) => {
  const eventParams: Record<string, string> = {
    event: 'event',
    eventCategory: slugify(category.replace(/\|/g, ''), {
      lower: true,
    }),
    eventAction: slugify(action.replace(/\|/g, ''), { lower: true }),
    eventLabel: slugify(label.replace(/\|/g, ''), {
      lower: true,
    }),
  }

  dispatchAnalytics(eventParams)
}

export const setGlobal = (params: Record<string, string>) => {
  const parameters = Object.keys(params).reduce((acc, key) => {
    return {
      ...acc,
      [key]: slugify(params[key], { lower: true }),
    }
  }, {})

  dispatchAnalytics(parameters)
}
